export enum NavigationItemType {
  DEFAULT = 'default',
  IMAGE_GRID = 'imageGrid',
  IMAGE_ROW = 'imageRow',
  BRAND_LOGOS = 'brandLogos',
  WALL_LARGE = 'wallLarge',
  WALL_SMALL = 'wallSmall',
  EXTRAS = 'extras',
}
